import React, { useState } from "react";
import { Commend3BadgeDescriptor } from "../Commend3Helper";
import { STALE_PROMOTION_HINT } from "../Commend3Constants";

type PromotionStatusBadgeProps = {
  id: string;
  badge: Commend3BadgeDescriptor;
  timestamp?: string | null;
};

const BADGE_STYLES: Record<string, React.CSSProperties> = {
  live: { background: "#E6F7FF", color: "#0066A0", border: "0.5px solid #7DD6FF" },
  promoted: { background: "#DCFCE7", color: "#109648", border: "none" },
  promoting: { background: "#FEF3C7", color: "#B45309", border: "0.5px solid #FCD34D" },
  notPromoted: { background: "#F4F5F9", color: "#59596E", border: "none" },
  stale: { background: "#FEE9EC", color: "#D60027", border: "0.5px solid #F9B8C2" },
};

const PromotionStatusBadge = ({ id, badge, timestamp }: PromotionStatusBadgeProps) => {
  const [tipOpen, setTipOpen] = useState<boolean>(false);
  const stale = badge.showAlert;
  const tone = stale ? BADGE_STYLES.stale : BADGE_STYLES[badge.state] ?? BADGE_STYLES.notPromoted;
  const label = stale ? `⚠ ${badge.label}` : badge.label;

  return (
    <span id={id} className="tw-relative tw-inline-flex tw-shrink-0 tw-flex-col tw-items-start">
      <span
        className="tw-inline-flex tw-items-center tw-gap-1 tw-rounded tw-px-[9px] tw-py-[3px] tw-text-[11px] tw-font-medium"
        style={tone}
        onMouseEnter={() => stale && setTipOpen(true)}
        onMouseLeave={() => setTipOpen(false)}
      >
        {label}
      </span>
      {stale && tipOpen ? (
        <span
          className="tw-absolute tw-left-0 tw-z-[80] tw-w-[206px] tw-rounded-md tw-px-2.5 tw-py-[7px] tw-text-[12px] tw-font-normal tw-text-white"
          style={{
            top: "calc(100% + 6px)",
            background: "#0B0C23",
            lineHeight: 1.45,
            boxShadow: "0 4px 12px rgba(3,5,98,.2)",
            whiteSpace: "normal",
            pointerEvents: "none",
          }}
        >
          {STALE_PROMOTION_HINT}
        </span>
      ) : null}
      {timestamp ? (
        <span className="tw-mt-1 tw-text-[11.5px] tw-font-normal tw-text-[#59596E]">
          {timestamp}
        </span>
      ) : null}
    </span>
  );
};

export default PromotionStatusBadge;
